/* global axios */
import ApiClient from '../ApiClient';

class CaptainMonitor extends ApiClient {
  constructor() {
    super('captain/monitor', { accountScoped: true });
  }

  get({ period = '24h' } = {}) {
    return axios.get(this.url, {
      params: { period },
    });
  }
}

export default new CaptainMonitor();
